import Experiment from '@mc/experiments-react'
import { useStaticData } from '@mc/static-data-react'
import { TrackingContainer } from '@mc/visibility'
import { CatalogExplorer } from 'components/CatalogExplorer'
import {
  ClassPageLocations,
  trackPageSectionViewed,
} from 'pages/classes/[slug]/events'
import type { Category } from 'types/data'
import { PEN_7401_FLAG } from '../constants'

const VISIBILITY_CONFIG = { threshold: 0.3 }

const Picker = () => {
  const { categories } = useStaticData<{ categories?: Category[] }>()

  if (!categories?.length) return null

  return (
    <TrackingContainer
      onFirstVisible={() =>
        trackPageSectionViewed(ClassPageLocations.CATEGORY_PICKER)
      }
      config={VISIBILITY_CONFIG}
    >
      <CatalogExplorer className='container mc-my-10' />
    </TrackingContainer>
  )
}

export const CategoryPicker = () => (
  <Experiment
    name={PEN_7401_FLAG}
    default={() => null}
    variant_1={() => <Picker />}
    track={false}
  />
)
